// PeptideVault v6.5 — Vendors, cycles, blends


// ── Vendor price-per-mg normalization ──
function calcPricePerMg(costPerUnit, mgPerVial) {
  if (!costPerUnit || !mgPerVial || mgPerVial <= 0) return null
  return (parseFloat(costPerUnit) / parseFloat(mgPerVial)).toFixed(2)
}

// ══════════════════════════════════════════════════════
// RENDER: VENDOR DIRECTORY
// ══════════════════════════════════════════════════════

function getVendor(id) { return S.vendors.find(v => v.id === id) }

function vendorProductCount(vendorName) {
  let count = 0
  const name = (vendorName||'').toLowerCase()
  for (const p of (S.peptides||[])) {
    for (const s of (p.skus||[])) {
      if ((s.vendor||'').toLowerCase() === name) count++
    }
  }
  for (const sup of (S.injectionSupplies||[])) {
    for (const s of (sup.skus||[])) {
      if ((s.vendor||'').toLowerCase() === name) count++
    }
  }
  return count
}

function renderVendorsTab() {
  const vendors = [...(S.vendors||[])].sort((a,b) => (a.name||'').localeCompare(b.name||''))

  return `<div class="tab-content">
    <div class="row" style="align-items:center;margin-bottom:16px;flex-wrap:wrap;gap:10px">
      <h2 style="font-size:20px;font-weight:700;margin:0">Vendor Directory</h2>
      <div class="spacer"></div>
      <button class="btn btn-primary btn-sm" onclick="openModal('addVendor')">+ Add Vendor</button>
      <button class="btn btn-secondary btn-sm" onclick="downloadVendorTemplate()">${ICONS.export} Template</button>
      <button class="btn btn-secondary btn-sm" onclick="importVendorsCSV()">${ICONS.export} Import</button>
      <button class="btn btn-secondary btn-sm" onclick="exportVendorsCSV()">${ICONS.export} Export</button>
    </div>

    ${vendors.length === 0 ? `<div class="card"><div class="empty-state" style="padding:48px"><div class="empty-icon">🏪</div><p>No vendors yet</p><span>Click "+ Add Vendor" to build your directory</span></div></div>` : `
    <div class="card">
      ${vendors.map((v, idx) => {
        const prodCount = vendorProductCount(v.name)
        // Migrate legacy website field to links array
        const links = v.links && v.links.length ? v.links : (v.website ? [{label:'Website',url:v.website}] : [])
        const contactItems = [
          v.email ? `<a href="mailto:${esc(v.email)}" style="font-size:12px;color:var(--blue)">📧 ${esc(v.email)}</a>` : '',
          v.telegram ? `<span style="font-size:12px;color:var(--text3)">✈️ ${esc(v.telegram)}</span>` : '',
          v.discord ? `<span style="font-size:12px;color:var(--text3)">💬 ${esc(v.discord)}</span>` : '',
          v.whatsapp ? `<span style="font-size:12px;color:var(--text3)">📱 ${esc(v.whatsapp)}</span>` : '',
        ].filter(Boolean)
        return `
        <div style="padding:12px 16px;${idx>0?'border-top:1px solid var(--border)':''}">
          <div class="row" style="align-items:center;gap:10px">
            <div style="flex:1;min-width:0">
              <div class="pep-name">${esc(v.name)}</div>
              ${links.length ? `<div style="display:flex;flex-wrap:wrap;gap:6px;margin-top:6px">${links.map(l => `<button class="btn btn-secondary btn-xs" onclick="openPepPedia('${esc(l.url)}')" title="${esc(l.url)}">🌐 ${esc(l.label||'Link')}</button>`).join('')}</div>` : ''}
              ${contactItems.length ? `<div style="display:flex;flex-wrap:wrap;gap:8px;margin-top:4px">${contactItems.join('')}</div>` : ''}
              ${v.notes ? `<div style="font-size:12px;color:var(--text4);margin-top:4px">${esc(v.notes)}</div>` : ''}
            </div>
            <span class="badge badge-gray">${prodCount} SKU${prodCount!==1?'s':''}</span>
            ${(() => { var coaCount = (S.coas||[]).filter(c => c.vendorId === v.id).length; return coaCount > 0 ? '<span class="badge" style="cursor:pointer" onclick="event.stopPropagation();setTab(\'coas\')">\uD83D\uDCDC ' + coaCount + ' COA' + (coaCount>1?'s':'') + '</span>' : '' })()}
            <button class="btn btn-ghost btn-xs" onclick="openModal('editVendor',{vendorId:'${v.id}'})">${ICONS.edit}</button>
            <button class="btn btn-ghost btn-xs" style="color:var(--red)" onclick="deleteVendor('${v.id}')">Delete</button>
          </div>
        </div>`}).join('')}
    </div>`}
  </div>`
}

function collectVendorLinks() {
  const container = document.getElementById('vend-links-rows')
  if (!container) return []
  const rows = container.querySelectorAll('.form-row')
  const links = []
  rows.forEach((row, i) => {
    const label = row.querySelector(`[id^="f-vend-link-label"]`)?.value?.trim() || ''
    const url = row.querySelector(`[id^="f-vend-link-url"]`)?.value?.trim() || ''
    if (label || url) links.push({ label: label || 'Link', url })
  })
  return links
}

function addVendorLinkRow() {
  const container = document.getElementById('vend-links-rows')
  if (!container) return
  const idx = container.children.length
  const row = document.createElement('div')
  row.className = 'form-row'
  row.style.cssText = 'gap:6px;align-items:center'
  row.innerHTML = `
    <input class="form-input" id="f-vend-link-label-${idx}" placeholder="Description (e.g. Main Site)" style="flex:1">
    <input class="form-input" id="f-vend-link-url-${idx}" placeholder="https://..." style="flex:1.5">
    <button class="btn btn-ghost btn-xs" style="color:var(--red);flex-shrink:0" onclick="this.closest('.form-row').remove()">✕</button>`
  container.appendChild(row)
}

function saveAddVendor() {
  const name = document.getElementById('f-vend-name')?.value?.trim()
  if (!name) { showToast('Name is required'); return }
  S.vendors.push({
    id: 'vend_'+uid(), name,
    links: collectVendorLinks(),
    telegram: document.getElementById('f-vend-telegram')?.value?.trim() || '',
    discord: document.getElementById('f-vend-discord')?.value?.trim() || '',
    whatsapp: document.getElementById('f-vend-whatsapp')?.value?.trim() || '',
    email: document.getElementById('f-vend-email')?.value?.trim() || '',
    notes: document.getElementById('f-vend-notes')?.value?.trim() || '',
  })
  save(); closeModal(); render(); showToast('Vendor added')
}

function saveEditVendor(vendorId) {
  const v = getVendor(vendorId)
  if (!v) return
  const oldName = v.name
  v.name = document.getElementById('f-vend-name')?.value?.trim() || v.name
  v.links = collectVendorLinks()
  v.website = ''  // clear legacy field
  v.telegram = document.getElementById('f-vend-telegram')?.value?.trim() || ''
  v.discord = document.getElementById('f-vend-discord')?.value?.trim() || ''
  v.whatsapp = document.getElementById('f-vend-whatsapp')?.value?.trim() || ''
  v.email = document.getElementById('f-vend-email')?.value?.trim() || ''
  v.notes = document.getElementById('f-vend-notes')?.value?.trim() || ''
  // Update vendor name on all linked SKUs if name changed
  if (v.name !== oldName) {
    for (const p of (S.peptides||[])) { for (const s of (p.skus||[])) { if (s.vendor === oldName) s.vendor = v.name } }
    for (const sup of (S.injectionSupplies||[])) { for (const s of (sup.skus||[])) { if (s.vendor === oldName) s.vendor = v.name } }
  }
  save(); closeModal(); render(); showToast('Vendor updated')
}

function deleteVendor(id) {
  appConfirm('Delete this vendor?', () => {
    S.vendors = S.vendors.filter(v => v.id !== id)
    save(); render(); showToast('Vendor deleted')
  })
}

function downloadVendorTemplate() {
  const headers = ['Vendor Name','Email','Telegram','Discord','WhatsApp','Notes']
  for (let i = 1; i <= 10; i++) { headers.push(`Link ${i} Description`, `Link ${i} URL`) }
  const example = ['Example Vendor','sales@example.com','@example','example#1234','+1234567890','Great vendor',
    'Main Website','https://example.com','Shop','https://shop.example.com','','','','','','','','','','','','','','','','']
  downloadTemplateCSV('Vendors_Template.csv', headers, example)
}

async function exportVendorsCSV() {
  if (!S.vendors?.length) { showToast('No vendors to export'); return }
  const headers = ['Vendor Name','Email','Telegram','Discord','WhatsApp','Notes']
  for (let i = 1; i <= 10; i++) { headers.push(`Link ${i} Description`, `Link ${i} URL`) }
  const rows = [headers]
  for (const v of [...S.vendors].sort((a,b) => (a.name||'').localeCompare(b.name||''))) {
    const links = v.links || (v.website ? [{label:'Website',url:v.website}] : [])
    const row = [v.name||'', v.email||'', v.telegram||'', v.discord||'', v.whatsapp||'', v.notes||'']
    for (let i = 0; i < 10; i++) {
      row.push(links[i]?.label || '', links[i]?.url || '')
    }
    rows.push(row)
  }
  const csv = rows.map(r => r.map(v => '"' + String(v).replace(/"/g,'""') + '"').join(',')).join('\n')
  const filename = `Vendors_${localDateKey()}.csv`
  if (window.api) {
    const savePath = await window.api.showSaveDialog({ title:'Export Vendors', defaultPath:filename, filters:[{name:'CSV',extensions:['csv']}] })
    if (savePath) { await window.api.writeFile(savePath, csv); showToast('Vendors exported') }
  } else {
    const a = document.createElement('a'); a.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv)
    a.download = filename; a.click(); showToast('Vendors exported')
  }
}

async function importVendorsCSV() {
  const input = document.createElement('input')
  input.type = 'file'; input.accept = '.csv'
  input.onchange = e => {
    const file = e.target.files[0]; if (!file) return
    const reader = new FileReader()
    reader.onload = ev => parseVendorsCSV(ev.target.result)
    reader.readAsText(file)
  }
  input.click()
}

async function parseVendorsCSV(text) {
  const lines = text.trim().split('\n').filter(l => l.trim())
  if (lines.length < 2) { showToast('CSV must have a header row and at least one data row'); return }

  function parseRow(line) {
    const result = []; let cur = '', inQuote = false
    for (let i = 0; i < line.length; i++) {
      const ch = line[i]
      if (ch === '"' && inQuote && line[i+1] === '"') { cur += '"'; i++ }
      else if (ch === '"') { inQuote = !inQuote }
      else if (ch === ',' && !inQuote) { result.push(cur); cur = '' }
      else cur += ch
    }
    result.push(cur)
    return result
  }

  const rawHeader = parseRow(lines[0]).map(h => h.replace(/^"|"$/g,'').trim().toLowerCase())
  const col = name => rawHeader.findIndex(h => h.includes(name))

  const iName = col('vendor name')
  if (iName === -1) { showToast('CSV must have a "Vendor Name" column'); return }
  const iEmail = col('email')
  const iTelegram = col('telegram')
  const iDiscord = col('discord')
  const iWhatsapp = col('whatsapp')
  const iNotes = rawHeader.findIndex(h => h === 'notes')

  // Find link columns
  const linkCols = []
  for (let i = 1; i <= 10; i++) {
    const descIdx = rawHeader.findIndex(h => h.includes(`link ${i} desc`))
    const urlIdx = rawHeader.findIndex(h => h.includes(`link ${i} url`))
    if (descIdx >= 0 || urlIdx >= 0) linkCols.push({ descIdx, urlIdx })
  }

  function field(row, idx) {
    if (idx === -1 || !row[idx]) return ''
    return row[idx].replace(/^"|"$/g, '').trim()
  }

  const imported = []
  for (let i = 1; i < lines.length; i++) {
    const row = parseRow(lines[i])
    const name = field(row, iName)
    if (!name) continue

    const links = []
    for (const lc of linkCols) {
      const label = field(row, lc.descIdx)
      const url = field(row, lc.urlIdx)
      if (label || url) links.push({ label: label || 'Link', url })
    }

    imported.push({
      id: 'vend_'+uid(), name,
      links,
      email: field(row, iEmail),
      telegram: field(row, iTelegram),
      discord: field(row, iDiscord),
      whatsapp: field(row, iWhatsapp),
      notes: field(row, iNotes),
    })
  }

  if (!imported.length) { showToast('No valid rows found'); return }

  const dupes = imported.filter(v => S.vendors.some(x => x.name.toLowerCase() === v.name.toLowerCase()))
  const msg = `Import ${imported.length} vendor${imported.length!==1?'s':''}?`
    + (dupes.length ? `\n\n⚠️ ${dupes.length} already exist and will be added as duplicates.` : '')
  if (!await asyncConfirm(msg)) return

  S.vendors.push(...imported)
  save(); render()
  showToast(`Imported ${imported.length} vendor${imported.length!==1?'s':''}`)
}


// ══════════════════════════════════════════════════════
// RENDER: CYCLE TIMELINE
// ══════════════════════════════════════════════════════

function getUserTimeline(userId) {
  return (S.cycleTimelines||[]).find(t => t.userId === userId)
}

function deriveCycles(entries, gapThreshold = 14) {
  if (!entries.length) return []
  const sorted = [...entries].sort((a,b) => a.date.localeCompare(b.date))
  const cycles = []
  let start = sorted[0], prev = sorted[0]
  const dosages = [prev.dosage]
  for (let i = 1; i < sorted.length; i++) {
    const gap = (new Date(sorted[i].date) - new Date(prev.date)) / 86400000
    if (gap > gapThreshold) {
      cycles.push({ start: start.date, end: prev.date, dosages: [...new Set(dosages)], days: Math.round((new Date(prev.date)-new Date(start.date))/86400000)+1 })
      start = sorted[i]
      dosages.length = 0
    }
    dosages.push(sorted[i].dosage)
    prev = sorted[i]
  }
  cycles.push({ start: start.date, end: prev.date, dosages: [...new Set(dosages)], days: Math.round((new Date(prev.date)-new Date(start.date))/86400000)+1 })
  return cycles
}

function compoundColor(idx) {
  const palette = ['#2563eb','#059669','#d97706','#dc2626','#7c3aed','#0891b2','#be185d','#4f46e5','#0d9488','#b45309',
    '#e11d48','#6d28d9','#0284c7','#c026d3','#15803d','#ea580c','#6366f1','#db2777','#0e7490','#a21caf']
  return palette[idx % palette.length]
}

function renderCycleTimelineTab() {
  const activeUsers = (S.users||[]).filter(u => u.active)
  const hasMultipleUsers = activeUsers.length > 1
  const currentUser = S._cycleUser || (activeUsers[0]?.id || '')
  const currentUserName = activeUsers.find(u => u.id === currentUser)?.name || ''
  const timeline = getUserTimeline(currentUser)
  const today = localDateKey()

  if (!timeline || !timeline.compounds?.length) {
    return `<div class="tab-content">
      <div class="row" style="align-items:center;margin-bottom:16px;flex-wrap:wrap;gap:10px">
        <h2 style="font-size:20px;font-weight:700;margin:0">Cycle Timeline</h2>
        <div class="spacer"></div>
        ${hasMultipleUsers ? activeUsers.map(u => `<button class="btn btn-sm ${currentUser===u.id?'btn-primary':'btn-secondary'}" onclick="S._cycleUser='${u.id}';render()">${esc(u.name)}</button>`).join('') : ''}
        <button class="btn btn-primary btn-sm" onclick="importCycleTimeline('${currentUser}')">Import Schedule</button>
      </div>
      <div class="card"><div class="empty-state" style="padding:48px"><div class="empty-icon">📅</div><p>No cycle timeline for ${esc(currentUserName)}</p><span>Import a schedule spreadsheet to visualize your cycles</span></div></div>
    </div>`
  }

  const compounds = timeline.compounds
  // Find date range
  let minDate = '9999', maxDate = '0000'
  for (const c of compounds) {
    for (const e of c.entries) {
      if (e.date < minDate) minDate = e.date
      if (e.date > maxDate) maxDate = e.date
    }
  }

  // Build month grid
  const startMonth = new Date(minDate.slice(0,7)+'-01')
  const endMonth = new Date(maxDate.slice(0,7)+'-01')
  endMonth.setMonth(endMonth.getMonth()+1)
  const months = []
  const d = new Date(startMonth)
  while (d <= endMonth) {
    months.push(d.toISOString().slice(0,7))
    d.setMonth(d.getMonth()+1)
  }
  const totalDays = Math.round((endMonth - startMonth) / 86400000)
  const todayPct = Math.max(0, Math.min(100, (new Date(today) - startMonth) / (endMonth - startMonth) * 100))

  // View window: default to 6 months centered on today
  const viewMonths = S._cycleViewMonths || 6
  const todayMonth = today.slice(0,7)
  let viewStart = months.indexOf(todayMonth)
  if (viewStart < 0) viewStart = 0
  viewStart = Math.max(0, viewStart - Math.floor(viewMonths/2))
  const viewEnd = Math.min(months.length, viewStart + viewMonths)
  const visibleMonths = months.slice(viewStart, viewEnd)
  const viewStartDate = new Date(visibleMonths[0]+'-01')
  const viewEndDate = new Date(visibleMonths[visibleMonths.length-1]+'-01')
  viewEndDate.setMonth(viewEndDate.getMonth()+1)
  const viewTotalDays = Math.round((viewEndDate - viewStartDate) / 86400000)

  function dateToPct(dateStr) {
    return Math.max(0, Math.min(100, (new Date(dateStr) - viewStartDate) / (viewEndDate - viewStartDate) * 100))
  }

  const todayViewPct = dateToPct(today)
  const showToday = todayViewPct > 0 && todayViewPct < 100

  return `<div class="tab-content">
    <div class="row" style="align-items:center;margin-bottom:16px;flex-wrap:wrap;gap:10px">
      <h2 style="font-size:20px;font-weight:700;margin:0">Cycle Timeline</h2>
      <div class="spacer"></div>
      ${hasMultipleUsers ? activeUsers.map(u => `<button class="btn btn-sm ${currentUser===u.id?'btn-primary':'btn-secondary'}" onclick="S._cycleUser='${u.id}';render()">${esc(u.name)}</button>`).join('') : ''}
      <select class="form-input" style="width:auto;font-size:12px" onchange="S._cycleViewMonths=+this.value;render()">
        ${[3,6,12,24].map(n => `<option value="${n}" ${viewMonths===n?'selected':''}>${n} months</option>`).join('')}
      </select>
      <button class="btn btn-ghost btn-sm" onclick="S._cycleViewMonths=${viewMonths};render()" title="Scroll left">◀</button>
      <button class="btn btn-ghost btn-sm" onclick="S._cycleViewMonths=${viewMonths};render()" title="Scroll right">▶</button>
      <button class="btn btn-primary btn-sm" onclick="importCycleTimeline('${currentUser}')">Import Schedule</button>
    </div>
    <div style="font-size:11px;color:var(--text4);margin-bottom:12px">
      Imported ${timeline.importedAt?.slice(0,10)||'—'} · ${compounds.length} compounds · ${minDate} to ${maxDate}
    </div>

    <!-- Timeline chart -->
    <div class="card" style="padding:0;overflow-x:auto;-webkit-overflow-scrolling:touch">
      <div style="min-width:600px;position:relative">
        <!-- Month headers -->
        <div style="display:flex;border-bottom:2px solid var(--border);background:var(--bg2)">
          <div style="width:180px;min-width:180px;padding:10px 12px;font-size:11px;font-weight:700;color:var(--text3)">Compound</div>
          <div style="flex:1;display:flex;position:relative">
            ${visibleMonths.map((m, i) => {
              const label = new Date(m+'-15').toLocaleDateString('en-US',{month:'short',year:'2-digit'})
              return `<div style="flex:1;text-align:center;font-size:10px;font-weight:600;color:var(--text4);padding:10px 0;border-left:1px solid var(--border)">${label}</div>`
            }).join('')}
          </div>
        </div>

        <!-- Compound rows -->
        ${compounds.map((c, ci) => {
          const color = compoundColor(ci)
          const cycles = deriveCycles(c.entries)
          const linkedNames = (c.linkedPeptideIds||[]).map(pid => { const p = (S.peptides||[]).find(x=>x.id===pid); return p?.name }).filter(Boolean)

          return `
        <div style="display:flex;border-bottom:1px solid var(--border);min-height:40px;align-items:center" class="timeline-row">
          <div style="width:180px;min-width:180px;padding:6px 12px">
            <div style="font-size:12px;font-weight:600;color:var(--text);white-space:nowrap;overflow:hidden;text-overflow:ellipsis" title="${esc(c.name)}">${esc(c.name)}</div>
            ${linkedNames.length ? `<div style="font-size:9px;color:var(--text4)">${esc(linkedNames.join(', '))}</div>` : ''}
          </div>
          <div style="flex:1;position:relative;height:32px">
            <!-- Month grid lines -->
            ${visibleMonths.map((m,i) => `<div style="position:absolute;left:${i/visibleMonths.length*100}%;top:0;bottom:0;border-left:1px solid var(--border)"></div>`).join('')}
            <!-- Cycle bars -->
            ${cycles.filter(cyc => {
              // Only show cycles that overlap with the visible window
              return cyc.end >= visibleMonths[0]+'-01' && cyc.start <= localDateStr(viewEndDate)
            }).map(cyc => {
              const left = dateToPct(cyc.start)
              const right = dateToPct(cyc.end)
              const width = Math.max(0.5, right - left)
              const isActive = cyc.start <= today && cyc.end >= today
              const isPast = cyc.end < today
              const isFuture = cyc.start > today
              const opacity = isPast ? '0.5' : '1'
              const doseLabel = cyc.dosages.length === 1 ? cyc.dosages[0] : cyc.dosages[0]+'→'+cyc.dosages[cyc.dosages.length-1]
              return `<div style="position:absolute;left:${left}%;width:${width}%;top:4px;height:24px;background:${color};opacity:${opacity};border-radius:4px;cursor:pointer;${isActive?'box-shadow:0 0 0 2px '+color+',0 0 0 4px rgba(0,0,0,.1)':''}" title="${esc(c.name)}: ${cyc.start} to ${cyc.end} (${cyc.days}d)\n${esc(doseLabel)}">
                <span style="font-size:9px;color:#fff;padding:0 4px;line-height:24px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:block">${esc(doseLabel)}</span>
              </div>`
            }).join('')}
            <!-- Today line -->
            ${showToday ? `<div style="position:absolute;left:${todayViewPct}%;top:0;bottom:0;width:2px;background:var(--red);z-index:5"></div>` : ''}
          </div>
        </div>`
        }).join('')}

        <!-- Today label -->
        ${showToday ? `<div style="position:absolute;top:0;left:calc(180px + (100% - 180px) * ${todayViewPct/100});transform:translateX(-50%);font-size:9px;font-weight:700;color:var(--red);background:var(--bg);padding:0 4px;z-index:6">TODAY</div>` : ''}
      </div>
    </div>

    <!-- Legend -->
    <div style="display:flex;flex-wrap:wrap;gap:12px;margin-top:12px;padding:8px 12px;background:var(--bg2);border-radius:var(--r2)">
      ${compounds.map((c,ci) => {
        const cycles = deriveCycles(c.entries)
        const activeCycle = cycles.find(cyc => cyc.start <= today && cyc.end >= today)
        const nextCycle = cycles.find(cyc => cyc.start > today)
        const statusLabel = activeCycle ? 'Active' : nextCycle ? 'Upcoming' : 'Completed'
        const statusDot = activeCycle ? '🟢' : nextCycle ? '🔵' : '⚪'
        return `<div style="display:flex;align-items:center;gap:4px;font-size:11px">
          <span style="width:10px;height:10px;border-radius:2px;background:${compoundColor(ci)};display:inline-block"></span>
          ${esc(c.name)} <span style="color:var(--text4)">${statusDot} ${statusLabel}</span>
        </div>`
      }).join('')}
    </div>

    <!-- Cycle detail cards -->
    <div style="margin-top:16px">
      <h3 style="font-size:15px;font-weight:700;margin:0 0 10px">Cycle Details</h3>
      <div style="display:grid;grid-template-columns:repeat(auto-fill,minmax(260px,1fr));gap:10px">
        ${compounds.map((c, ci) => {
          const cycles = deriveCycles(c.entries)
          const activeCycle = cycles.find(cyc => cyc.start <= today && cyc.end >= today)
          const nextCycle = cycles.find(cyc => cyc.start > today)
          const freq = c.entries.length > 1 ? Math.round((new Date(c.entries[c.entries.length-1].date) - new Date(c.entries[0].date)) / 86400000 / (c.entries.length-1) * 10)/10 : 0
          const freqLabel = freq <= 1.2 ? 'Daily' : freq <= 2.5 ? 'Every other day' : freq <= 3.5 ? 'Every 3 days' : freq <= 7.5 ? 'Weekly' : `Every ${Math.round(freq)} days`
          return `
        <div class="card" style="padding:12px;border-left:3px solid ${compoundColor(ci)}">
          <div style="font-size:13px;font-weight:700;margin-bottom:4px">${esc(c.name)}</div>
          <div style="font-size:11px;color:var(--text3);line-height:1.6">
            <div>${cycles.length} cycle${cycles.length!==1?'s':''} · ${freqLabel}</div>
            <div>Dosages: ${esc([...new Set(c.entries.map(e=>e.dosage))].join(', '))}</div>
            ${activeCycle ? `<div style="color:var(--green)">🟢 Active: ${activeCycle.start} to ${activeCycle.end} (day ${Math.round((new Date(today)-new Date(activeCycle.start))/86400000)+1} of ${activeCycle.days})</div>` : ''}
            ${!activeCycle && nextCycle ? `<div style="color:var(--blue)">🔵 Next: ${nextCycle.start} (in ${Math.round((new Date(nextCycle.start)-new Date(today))/86400000)}d)</div>` : ''}
            ${!activeCycle && !nextCycle ? `<div style="color:var(--text4)">⚪ Completed</div>` : ''}
          </div>
        </div>`}).join('')}
      </div>
    </div>
  </div>`
}

// ── Cycle Timeline Import ──

function importCycleTimeline(userId) {
  const input = document.createElement('input')
  input.type = 'file'; input.accept = '.csv,.xlsx'
  input.onchange = async e => {
    const file = e.target.files[0]; if (!file) return
    showToast('Parsing schedule…')
    try {
      if (file.name.endsWith('.csv')) {
        const text = await file.text()
        parseCycleCSV(text, userId)
      } else {
        const data = await file.arrayBuffer()
        const rows = await parseXlsxNative(new Uint8Array(data))
        parseCycleRows(rows, userId)
      }
    } catch(err) {
      showToast('Failed to parse: ' + err.message)
      console.error(err)
    }
  }
  input.click()
}

// Minimal native XLSX parser — no external libraries needed
async function parseXlsxNative(bytes) {
  // XLSX is a ZIP of XML files. Extract using native DecompressionStream.
  const entries = await extractZip(bytes)
  
  // Parse shared strings (xl/sharedStrings.xml)
  const ssXml = entries['xl/sharedStrings.xml'] || ''
  const sharedStrings = []
  const ssRe = /<si>[\s\S]*?<\/si>/g
  let ssM
  while ((ssM = ssRe.exec(ssXml)) !== null) {
    // Collect all <t> values within this <si> and join them
    const tRe = /<t[^>]*>([^<]*)<\/t>/g
    let tM, parts = []
    while ((tM = tRe.exec(ssM[0])) !== null) parts.push(tM[1])
    sharedStrings.push(parts.join(''))
  }
  
  // Parse sheet1 (xl/worksheets/sheet1.xml)
  const sheetXml = entries['xl/worksheets/sheet1.xml'] || ''
  const rows = []
  const rowRe = /<row[^>]*>([\s\S]*?)<\/row>/g
  let rowM
  while ((rowM = rowRe.exec(sheetXml)) !== null) {
    const cells = []
    const rowXml = rowM[1]
    // Split on <c to get individual cell chunks — avoids regex issues with self-closing tags
    const cellChunks = rowXml.split(/<c\s+/).slice(1)
    for (const chunk of cellChunks) {
      const refMatch = chunk.match(/^r="([A-Z]+)(\d+)"/)
      if (!refMatch) continue
      const col = refMatch[1]
      const isShared = /\bt="s"/.test(chunk)
      const valMatch = chunk.match(/<v>([^<]*)<\/v>/)
      let val = valMatch ? valMatch[1] : ''
      if (isShared && sharedStrings[+val] !== undefined) val = sharedStrings[+val]
      let colIdx = 0
      for (let i = 0; i < col.length; i++) colIdx = colIdx * 26 + (col.charCodeAt(i) - 64)
      cells[colIdx - 1] = val
    }
    const filled = Array.from({length: cells.length}, (_, i) => cells[i] || '')
    rows.push(filled)
  }
  
  if (rows.length < 2) throw new Error('No data found in spreadsheet')
  return rows
}

async function extractZip(bytes) {
  const files = {}
  const view = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength)
  const decoder = new TextDecoder()
  let offset = 0

  while (offset < bytes.length - 30) {
    const sig = view.getUint32(offset, true)
    if (sig !== 0x04034b50) break

    const method = view.getUint16(offset + 8, true)
    const compSize = view.getUint32(offset + 18, true)
    const uncompSize = view.getUint32(offset + 22, true)
    const nameLen = view.getUint16(offset + 26, true)
    const extraLen = view.getUint16(offset + 28, true)
    const name = decoder.decode(bytes.slice(offset + 30, offset + 30 + nameLen))
    const dataStart = offset + 30 + nameLen + extraLen
    const rawData = bytes.slice(dataStart, dataStart + compSize)

    if (name.endsWith('.xml') || name.endsWith('.rels')) {
      if (method === 0) {
        files[name] = decoder.decode(rawData)
      } else if (method === 8) {
        try {
          const ds = new DecompressionStream('deflate-raw')
          const writer = ds.writable.getWriter()
          const reader = ds.readable.getReader()
          writer.write(rawData).then(() => writer.close())
          const chunks = []
          while (true) {
            const { done, value } = await reader.read()
            if (done) break
            chunks.push(value)
          }
          const total = chunks.reduce((a, c) => a + c.length, 0)
          const result = new Uint8Array(total)
          let pos = 0
          for (const c of chunks) { result.set(c, pos); pos += c.length }
          files[name] = decoder.decode(result)
        } catch (e) {
          // Skip unreadable entries
        }
      }
    }
    offset = dataStart + compSize
  }
  return files
}

function parseCycleCSV(text, userId) {
  const lines = text.trim().split('\n')
  if (lines.length < 2) { showToast('No data found'); return }
  function parseRow(line) {
    const result = []; let cur = '', inQuote = false
    for (let i = 0; i < line.length; i++) {
      const ch = line[i]
      if (ch === '"') { inQuote = !inQuote }
      else if (ch === ',' && !inQuote) { result.push(cur.trim()); cur = '' }
      else cur += ch
    }
    result.push(cur.trim())
    return result
  }
  parseCycleRows(lines.map(l => parseRow(l)), userId)
}

function parseCycleRows(rows, userId) {
  if (rows.length < 2) { showToast('No data found'); return }
  const header = rows[0]
  const rawCompounds = header.slice(2).map(h => h ? String(h).replace(/\u00a0/g,' ').trim() : '')
  const compounds = rawCompounds.map(name => ({ name, entries: [] }))

  for (let i = 1; i < rows.length; i++) {
    const row = rows[i]
    let dateStr = row[0]
    if (!dateStr) continue
    let date
    if (dateStr instanceof Date) { date = dateStr.toISOString().slice(0,10) }
    else if (+dateStr > 30000) { date = new Date((+dateStr - 25569) * 86400000).toISOString().slice(0,10) }
    else { try { const d = new Date(String(dateStr).replace(/"/g,'')); date = d.toISOString().slice(0,10) } catch(e) { continue } }
    if (!date || !date.startsWith('20')) continue

    for (let ci = 0; ci < rawCompounds.length; ci++) {
      if (!rawCompounds[ci]) continue  // skip empty header columns
      const val = String(row[ci+2]||'').replace(/"/g,'').trim()
      if (val && val !== 'undefined') compounds[ci].entries.push({ date, dosage: val })
    }
  }

  finalizeCycleImport(compounds.filter(c => c.name && c.entries.length > 0), userId)
}

function finalizeCycleImport(compounds, userId) {
  if (!compounds.length) { showToast('No compound data found'); return }
  
  // Auto-match compounds to existing peptides
  const peptides = S.peptides || []
  for (const c of compounds) {
    c.linkedPeptideIds = []
    // Exact match
    const exact = peptides.find(p => p.name.toLowerCase() === c.name.toLowerCase())
    if (exact) { c.linkedPeptideIds = [exact.id]; continue }
    // Partial match — check if compound name contains a peptide name
    for (const p of peptides) {
      if (c.name.toLowerCase().includes(p.name.toLowerCase())) {
        c.linkedPeptideIds.push(p.id)
      }
    }
  }
  
  // Check for unlinked compounds
  const unlinked = compounds.filter(c => c.linkedPeptideIds.length === 0)
  
  // Store parsed compounds temporarily
  S._pendingCycleImport = { compounds, userId }
  
  if (unlinked.length > 0) {
    // Show linking modal
    openModal('cycleLink', { compounds, userId, unlinkedIdx: 0 })
  } else {
    // All matched — save directly
    saveCycleImport(compounds, userId)
  }
}

function saveCycleImport(compounds, userId) {
  // Remove existing timeline for this user
  S.cycleTimelines = (S.cycleTimelines||[]).filter(t => t.userId !== userId)
  
  S.cycleTimelines.push({
    id: 'ct_'+uid(),
    userId,
    importedAt: new Date().toISOString(),
    compounds
  })
  
  save(); closeModal(); render()
  showToast(`Imported ${compounds.length} compounds`)
}

function saveCycleLinkAndContinue() {
  const d = S.modalData
  const compound = d.compounds[d.unlinkedIdx]
  
  // Collect checked peptides
  const checks = document.querySelectorAll('.cycle-link-cb:checked')
  compound.linkedPeptideIds = [...checks].map(cb => cb.value)
  
  // Move to next unlinked compound
  const nextIdx = d.compounds.findIndex((c, i) => i > d.unlinkedIdx && c.linkedPeptideIds.length === 0)
  
  if (nextIdx >= 0) {
    openModal('cycleLink', { ...d, unlinkedIdx: nextIdx })
  } else {
    saveCycleImport(d.compounds, d.userId)
  }
}

// ══════════════════════════════════════════════════════
// RENDER: BLEND BUILDER
// ══════════════════════════════════════════════════════

function blendDoseBreakdown(blend) {
  const totalMl = +blend.diluentMl || 1
  const doseVol = +blend.doseVolumeMl || 0.1
  const results = (blend.components||[]).map(c => {
    const amount = +c.amountMg || 0
    const concPerMl = amount / totalMl
    const perDose = concPerMl * doseVol
    const unit = c.amountUnit || 'mg'
    return { name: c.peptideName, perDose, unit, concPerMl, totalAmount: amount }
  })
  const totalDoses = Math.floor(totalMl / doseVol)
  return { results, totalDoses, doseVol, totalMl }
}

function renderBlendsTab() {
  const userBlends = (S.blends||[]).sort((a,b) => (a.name||'').localeCompare(b.name||''))

  return `<div class="tab-content">
    <div class="row" style="align-items:center;margin-bottom:16px;flex-wrap:wrap;gap:10px">
      <h2 style="font-size:20px;font-weight:700;margin:0">Blend Builder</h2>
      <div class="spacer"></div>
      <button class="btn btn-primary btn-sm" onclick="openModal('addBlend')">+ New Blend</button>
    </div>

    ${userBlends.length === 0 ? `<div class="card"><div class="empty-state" style="padding:48px"><div class="empty-icon">🧪</div><p>No blends yet</p><span>Create a blend to calculate what each dose delivers</span></div></div>` : `
    <div style="display:grid;grid-template-columns:repeat(auto-fill,minmax(340px,1fr));gap:14px">
      ${userBlends.map(blend => {
        const bd = blendDoseBreakdown(blend)
        return `
      <div class="card" style="padding:0;overflow:hidden">
        <div style="padding:14px 16px;border-bottom:1px solid var(--border)">
          <div class="row" style="align-items:center;gap:8px">
            <div style="font-size:15px;font-weight:700;flex:1">${esc(blend.name||'Unnamed Blend')}</div>
            <button class="btn btn-ghost btn-xs" onclick="openModal('editBlend',{blendId:'${blend.id}'})">${ICONS.edit}</button>
            <button class="btn btn-ghost btn-xs" style="color:var(--red)" onclick="deleteBlend('${blend.id}')">Delete</button>
          </div>
          <div style="font-size:11px;color:var(--text4);margin-top:2px">
            ${esc(blend.diluentType||'BAC Water')} · ${blend.diluentMl}mL diluent · ${bd.totalDoses} doses of ${bd.doseVol}mL
          </div>
        </div>

        <!-- Components -->
        <div style="padding:10px 16px">
          <div style="font-size:10px;font-weight:700;color:var(--text4);margin-bottom:6px">COMPONENTS</div>
          ${(blend.components||[]).map(c => `
          <div style="display:flex;justify-content:space-between;padding:3px 0;font-size:12px;border-bottom:1px solid var(--border)">
            <span style="font-weight:600">${esc(c.peptideName)}</span>
            <span style="color:var(--text3)">${c.amountMg} ${c.amountUnit||'mg'}</span>
          </div>`).join('')}
        </div>

        <!-- Per-dose breakdown -->
        <div style="padding:10px 16px;background:var(--bg2)">
          <div style="font-size:10px;font-weight:700;color:var(--text4);margin-bottom:6px">PER DOSE (${bd.doseVol}mL)</div>
          ${bd.results.map(r => `
          <div style="display:flex;justify-content:space-between;padding:4px 0;font-size:13px">
            <span style="font-weight:600;color:var(--text)">${esc(r.name)}</span>
            <span style="font-weight:700;color:var(--blue)">${r.perDose < 1 ? (r.perDose*1000).toFixed(1)+' mcg' : r.perDose.toFixed(2)+' '+r.unit}</span>
          </div>`).join('')}
          <div style="border-top:1px solid var(--border);padding-top:6px;margin-top:4px;font-size:11px;color:var(--text3)">
            Concentration: ${bd.results.map(r => esc(r.name)+': '+r.concPerMl.toFixed(2)+' '+r.unit+'/mL').join(' · ')}
          </div>
        </div>

        ${blend.notes ? `<div style="padding:8px 16px;font-size:11px;color:var(--text4)">${esc(blend.notes)}</div>` : ''}
      </div>`}).join('')}
    </div>`}
  </div>`
}

function saveAddBlend() {
  const name = document.getElementById('f-blend-name')?.value?.trim()
  if (!name) { showToast('Name is required'); return }
  const components = collectBlendComponents()
  if (!components.length) { showToast('Add at least one component'); return }
  S.blends.push({
    id: 'bl_'+uid(), name,
    components,
    diluentType: document.getElementById('f-blend-diluent')?.value || 'BAC Water',
    diluentMl: +(document.getElementById('f-blend-diluent-ml')?.value) || 3,
    doseVolumeMl: +(document.getElementById('f-blend-dose-vol')?.value) || 0.1,
    notes: document.getElementById('f-blend-notes')?.value?.trim() || '',
    createdAt: new Date().toISOString()
  })
  save(); closeModal(); render(); showToast('Blend created')
}

function saveEditBlend(blendId) {
  const blend = S.blends.find(b => b.id === blendId)
  if (!blend) return
  blend.name = document.getElementById('f-blend-name')?.value?.trim() || blend.name
  blend.components = collectBlendComponents()
  blend.diluentType = document.getElementById('f-blend-diluent')?.value || 'BAC Water'
  blend.diluentMl = +(document.getElementById('f-blend-diluent-ml')?.value) || 3
  blend.doseVolumeMl = +(document.getElementById('f-blend-dose-vol')?.value) || 0.1
  blend.notes = document.getElementById('f-blend-notes')?.value?.trim() || ''
  save(); closeModal(); render(); showToast('Blend updated')
}

function deleteBlend(id) {
  appConfirm('Delete this blend?', () => {
    S.blends = S.blends.filter(b => b.id !== id)
    save(); render(); showToast('Blend deleted')
  })
}

function collectBlendComponents() {
  const container = document.getElementById('blend-comp-rows')
  if (!container) return []
  const comps = []
  container.querySelectorAll('.blend-comp-row').forEach(row => {
    const peptideId = row.querySelector('.bc-peptide')?.value || ''
    const peptideName = row.querySelector('.bc-name')?.value?.trim() || ''
    const amountMg = +(row.querySelector('.bc-amount')?.value) || 0
    const amountUnit = row.querySelector('.bc-unit')?.value || 'mg'
    if ((peptideName || peptideId) && amountMg > 0) {
      const name = peptideName || (S.peptides.find(p=>p.id===peptideId)?.name || '')
      comps.push({ peptideId, peptideName: name, amountMg, amountUnit })
    }
  })
  return comps
}

function addBlendComponentRow() {
  const container = document.getElementById('blend-comp-rows')
  if (!container) return
  const idx = container.children.length
  const row = document.createElement('div')
  row.className = 'blend-comp-row'
  row.style.cssText = 'display:grid;grid-template-columns:2fr 1fr auto auto;gap:6px;align-items:center'
  row.innerHTML = `
    <select class="form-input bc-peptide" style="font-size:12px" onchange="this.nextElementSibling?.remove();if(!this.value){const inp=document.createElement('input');inp.className='form-input bc-name';inp.style.fontSize='12px';inp.placeholder='Custom name';this.after(inp)}">
      <option value="">— Custom —</option>
      ${[...S.peptides].sort((a,b)=>a.name.localeCompare(b.name)).map(p => `<option value="${p.id}">${esc(p.name)}</option>`).join('')}
    </select>
    <div style="display:flex;gap:4px">
      <input class="form-input bc-amount" type="number" step="0.01" placeholder="Amount" style="font-size:12px;flex:1">
      <select class="form-input bc-unit" style="font-size:12px;width:65px">
        <option>mg</option><option>mcg</option><option>IU</option>
      </select>
    </div>
    <button class="btn btn-ghost btn-xs" style="color:var(--red)" onclick="this.closest('.blend-comp-row').remove()">✕</button>`
  container.appendChild(row)
}

export {
  calcPricePerMg,
  getVendor,
  vendorProductCount,
  renderVendorsTab,
  collectVendorLinks,
  addVendorLinkRow,
  saveAddVendor,
  saveEditVendor,
  deleteVendor,
  downloadVendorTemplate,
  exportVendorsCSV,
  importVendorsCSV,
  parseVendorsCSV,
  getUserTimeline,
  deriveCycles,
  compoundColor,
  renderCycleTimelineTab,
  importCycleTimeline,
  parseXlsxNative,
  extractZip,
  parseCycleCSV,
  parseCycleRows,
  finalizeCycleImport,
  saveCycleImport,
  saveCycleLinkAndContinue,
  blendDoseBreakdown,
  renderBlendsTab,
  saveAddBlend,
  saveEditBlend,
  deleteBlend,
  collectBlendComponents,
  addBlendComponentRow
}
